import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "@mui/material";

import ServiceDetails from "@components/main/serviceMarketplace/ServiceDetails";
import { useGetServices } from "@api";
import { useUserStore } from "@store/user";
import { Box, Typography } from "@components/base";

interface ServiceDetailProps {
  serviceId?: string;
}

const ServiceDetail: FC<ServiceDetailProps> = ({ serviceId }) => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { services, servicesEnabled, isPendingServices } = useGetServices(user);

  const service = useMemo(() => {
    if (!services || !serviceId) return null;

    return services.find((s) => s.id.toString() === serviceId) || null;
  }, [services, serviceId]);

  if (isPendingServices) {
    return (
      <Container>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <Typography>{t("common.loading")}</Typography>
        </Box>
      </Container>
    );
  }

  if (!servicesEnabled) {
    return (
      <Container>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <Typography>{t("common.accessDenied")}</Typography>
        </Box>
      </Container>
    );
  }

  if (!service) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <Typography>{t("serviceDetails.notFound")}</Typography>
      </Box>
    );
  }

  return (
    <Box py={3}>
      <ServiceDetails service={service} />
    </Box>
  );
};

export default ServiceDetail;
